import React, { useState } from 'react';
import { Box, Grid, Paper, Typography, TextField, Button, CircularProgress } from '@mui/material';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SideMenu from '../components/SideMenu'; // Certifique-se do caminho correto
import ThermostatIcon from '@mui/icons-material/Thermostat'; // Ícone de temperatura
import OpacityIcon from '@mui/icons-material/Opacity'; // Ícone de umidade
import CompressIcon from '@mui/icons-material/Compress'; // Ícone de pressão
import LightbulbIcon from '@mui/icons-material/Lightbulb'; // Ícone de luminosidade

const AddSensorData = () => {
    const [sensors, setSensors] = useState([
        { id: 1, sensorId: 'TEMP001', sensorType: 'Temperatura', location: { latitude: -23.5505, longitude: -46.6333 }, status: 'Active' },
        { id: 2, sensorId: 'HUM002', sensorType: 'Umidade', location: { latitude: -22.9068, longitude: -43.1729 }, status: 'Inactive' },
        { id: 3, sensorId: 'PRESS003', sensorType: 'Pressão', location: { latitude: -15.7801, longitude: -47.9292 }, status: 'Active' },
        { id: 4, sensorId: 'LIGHT004', sensorType: 'Luminosidade', location: { latitude: -30.0346, longitude: -51.2177 }, status: 'Active' },
    ]);
    const [showForm, setShowForm] = useState(false); // Controla exibição do formulário
    const [sensorId, setSensorId] = useState('');
    const [sensorType, setSensorType] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [loading, setLoading] = useState(false);

    // Adicionar novo sensor
    const handleAddSensor = (e) => {
        e.preventDefault();
        setLoading(true);
        setTimeout(() => {
            setSensors([
                ...sensors,
                {
                    id: sensors.length + 1,
                    sensorId,
                    sensorType,
                    location: { latitude, longitude },
                    status: 'Inactive',
                },
            ]);
            setSensorId('');
            setSensorType('');
            setLatitude('');
            setLongitude('');
            setShowForm(false);
            setLoading(false);
            toast.success('Sensor adicionado com sucesso!');
        }, 1000);
    };

    // Alterar status ON/OFF de um sensor
    const toggleSensorStatus = (id) => {
        setSensors(
            sensors.map((sensor) =>
                sensor.id === id
                    ? { ...sensor, status: sensor.status === 'Active' ? 'Inactive' : 'Active' }
                    : sensor
            )
        );
        toast.success('Status do sensor atualizado!');
    };

    // Função para obter ícones com base no tipo do sensor
    const getSensorIcon = (sensorType) => {
        switch (sensorType) {
            case 'Temperatura':
                return <ThermostatIcon sx={{ fontSize: 40, color: 'red' }} />;
            case 'Umidade':
                return <OpacityIcon sx={{ fontSize: 40, color: 'blue' }} />;
            case 'Pressão':
                return <CompressIcon sx={{ fontSize: 40, color: 'green' }} />;
            case 'Luminosidade':
                return <LightbulbIcon sx={{ fontSize: 40, color: 'yellow' }} />;
            default:
                return null;
        }
    };

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            {/* SideMenu */}
            <Box sx={{ width: '250px' }}>
                <SideMenu />
            </Box>

            {/* Conteúdo principal */}
            <Box sx={{ flexGrow: 1, padding: '20px' }}>
                <ToastContainer />
                <Typography variant="h4" align="center" gutterBottom>
                    Sensores IoT
                </Typography>

                {/* Cards de Sensores */}
                <Grid container spacing={3}>
                    {sensors.map((sensor) => (
                        <Grid item xs={12} md={6} lg={4} key={sensor.id}>
                            <Paper elevation={3} sx={{ padding: '20px', borderRadius: '10px', textAlign: 'center' }}>
                                {/* Ícone do sensor */}
                                {getSensorIcon(sensor.sensorType)}
                                <Typography variant="h6"><strong>ID:</strong> {sensor.sensorId}</Typography>
                                <Typography variant="body1"><strong>Tipo:</strong> {sensor.sensorType}</Typography>
                                <Typography variant="body2"><strong>Localização:</strong> {sensor.location.latitude}, {sensor.location.longitude}</Typography>
                                <Typography variant="body2"><strong>Status:</strong> {sensor.status}</Typography>
                                <Button
                                    variant="contained"
                                    color={sensor.status === 'Active' ? 'error' : 'success'}
                                    onClick={() => toggleSensorStatus(sensor.id)}
                                    sx={{ marginTop: '10px' }}
                                >
                                    {sensor.status === 'Active' ? 'Desligar' : 'Ligar'}
                                </Button>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>

                {/* Botão para mostrar o formulário */}
                {!showForm && (
                    <Box sx={{ textAlign: 'center', marginTop: '20px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setShowForm(true)}
                            sx={{ fontWeight: 'bold', padding: '10px 20px' }}
                        >
                            + Adicionar Sensor
                        </Button>
                    </Box>
                )}

                {/* Formulário para Adicionar Sensor */}
                {showForm && (
                    <Box component="form" onSubmit={handleAddSensor} noValidate sx={{ marginTop: '20px', maxWidth: '600px', margin: '20px auto' }}>
                        <Typography variant="h6" align="center">Adicionar Sensor</Typography>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            label="ID do Sensor"
                            value={sensorId}
                            onChange={(e) => setSensorId(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            label="Tipo do Sensor"
                            value={sensorType}
                            onChange={(e) => setSensorType(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            label="Latitude"
                            type="number"
                            value={latitude}
                            onChange={(e) => setLatitude(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            label="Longitude"
                            type="number"
                            value={longitude}
                            onChange={(e) => setLongitude(e.target.value)}
                        />
                        <Box sx={{ textAlign: 'center' }}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                sx={{ marginTop: '20px', marginBottom: '10px', width: '50%' }}
                            >
                                {loading ? <CircularProgress size={24} /> : 'Adicionar'}
                            </Button>
                            <Button
                                variant="outlined"
                                color="secondary"
                                onClick={() => setShowForm(false)}
                                sx={{ width: '50%' }}
                            >
                                Cancelar
                            </Button>
                        </Box>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default AddSensorData;
